export default __webpack_public_path__ + "static/media/add_folder_linear.46285944.svg";